module.exports = __webpack_public_path__ + "img/icon_basket.b7626917.png";